export default {"src":"/_next/static/image/src/components/icons/DangerScale.062ec4da0148dd29f872353bcdd8a34c.svg","height":960,"width":1152};